import { render, staticRenderFns } from "./WhatsAppBillPrint.vue?vue&type=template&id=045ecb52&"
import script from "./WhatsAppBillPrint.vue?vue&type=script&lang=js&"
export * from "./WhatsAppBillPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports